import LoadingApp from './LoadingApp'
export default LoadingApp
